export const FEATURED_CITIES_DEALERS_COUNT = [
  {
    provinceId: 28,
    dealersCount: 200
  },
  {
    provinceId: 8,
    dealersCount: 175
  },
  {
    provinceId: 46,
    dealersCount: 60
  },
  {
    provinceId: 41,
    dealersCount: 25
  },
  {
    provinceId: 50,
    dealersCount: 25
  },
  {
    provinceId: 29,
    dealersCount: 35
  },
  {
    provinceId: 30,
    dealersCount: 30
  },
  {
    provinceId: 7,
    dealersCount: 20
  },
  {
    provinceId: 35,
    dealersCount: 30
  },
  {
    provinceId: 48,
    dealersCount: 15
  }
]
